module.exports = __webpack_public_path__ + "static/media/1005521.cc5f1d83.png";